import React from "react";
import { useParams } from "react-router-dom";
//#region types
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
import { BusinessUnitFormTypes } from "models/formTypes";
//#endregion
//#region components
import {
  LoadingWithLogo,
  PageLayouts,
  ReloadEvent,
  RouteBreadCrumb,
  SearchContextProvider,
  useMountedState,
} from "components/common";
import BusinessUnitListViewContainer from "./businessUnitListViewContainer";
import CreateProfileButtons from "./createProfileButtons";
import useBusinessUnitProfileFilterDefinition from "./forms/useBusinessUnitProfileFilterDefinition";
import { useBusinessUnitService } from "serviceHooks";
import cssExports from "theme/styles/main.module.scss";
//#endregion

const BusinessUnitProfile: React.FC = () => {
  const businessUnitService = useBusinessUnitService();
  const urlParams = useParams<EntityIdParams>();
  const id = urlParams.id!;
  const [loading, setLoading] = React.useState<boolean>(true);
  const [businessUnit, setbusinessUnit] = React.useState<ApiModel.BusinessUnit>();
  const { filterFormFields, filterQueryStateHandler } = useBusinessUnitProfileFilterDefinition();
  const { getMounted } = useMountedState();

  const getBusinessUnit = () => {
    businessUnitService
      .getBusinessUnit(id)
      .then((result) => {
        if (getMounted()) {
          setbusinessUnit(result);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadData = () => {
    getBusinessUnit();
  };

  React.useEffect(() => {
    setLoading(true);
    loadData();
  }, [id]);

  return loading ? (
    <LoadingWithLogo />
  ) : (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <SearchContextProvider>
          {
            <PageLayouts.DashboardLayout<BusinessUnitFormTypes.Filter>
              entityKey={id}
              title={businessUnit?.name ? businessUnit?.name : ""}
              topRightButtons={
                <CreateProfileButtons reloadList={reload} businessUnit={businessUnit as ApiModel.BusinessUnit} />
              }
              hasPermissions={businessUnitService.hasEditPermissions()}
              breadCrumb={
                <RouteBreadCrumb className={cssExports.dashBoardNavigation} current={businessUnit?.name ?? ""} />
              }
              filterFields={filterFormFields}
              initialFilter={{
                businessUnitId: businessUnit?.id ?? "",
              }}
              filterQueryStateHandler={filterQueryStateHandler}
            >
              <BusinessUnitListViewContainer businessUnitId={id} reloadKey={reloadKey} />
            </PageLayouts.DashboardLayout>
          }
        </SearchContextProvider>
      )}
    />
  );
};

export default BusinessUnitProfile;
